<template>
    <div class="input-help-text">
        <slot />
    </div>
</template>
